import { ActionTree } from "vuex";
import {
  RootState,
  FridgeDetailsState,
  FridgeDetailsSetSettingsList,
  FridgeDetailsPushSettings,
  FridgeDetailsMyAssistSettingItem,
  FridgeCoolingAssistSettingItem
} from "@/types/fridgeDetails";
import store from "@/store";
import { apiFridgeClient, translateFridgeParameter } from "@/client/api-client";
import { fridgeFileDownloadClient } from "@/client/file-download-client";
import { API_URL_FRIDGE } from "@/const/api-const";
import { FILE_URL_FRIDGE } from "@/const/file-url-const";
import NativeClient from "@/client/native-client";

const actions: ActionTree<FridgeDetailsState, RootState> = {
  // エコナビ情報取得
  getEconaviInfo: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getEconaviInfo start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getEconaviInfo apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.ECONAVI.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getEconaviInfo api response = " + JSON.stringify(res.data));
    commit("updateEconaviInfo", res.data);
  },
  // ドア開閉情報
  getDoorOpenInfo: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getDoorOpenInfo start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getDoorOpenInfo apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.DOOROPNEINFO.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getDoorOpenInfo api response = " + JSON.stringify(res.data));
    commit("updateDoorOpenInfo", res.data);
  },
  // Push通知設定状態取得
  getPushSettings: async ({ commit }, termId: string) => {
    NativeClient.sendDebugLog("actions.ts getPushSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getPushSettings apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.PUSHSETTING.replace("$applianceId", targetApplianceId).replace("$termId", apiParams.termId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getPushSettings response body = " + JSON.stringify(res.data));
    commit("updatePushSettings", res.data);
  },
  // Push通知設定状態登録
  registPushSettings: async ({ commit }, param: FridgeDetailsPushSettings) => {
    NativeClient.sendDebugLog("actions.ts registPushSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts registPushSettings apiParams = " + JSON.stringify(apiParams));
    param.term_id = apiParams.termId;
    NativeClient.sendDebugLog("actions.ts registPushSettings request body = " + JSON.stringify(param));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.PUSHSETTING_REGIST.replace("$applianceId", targetApplianceId);
    await apiFridgeClient.put(apiPath, param);
  },
  // 月別削減金額取得
  getReductionInfo: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getReductionInfo start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getReductionInfo apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.REDUCTIONINFO.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getReductionInfo api response = " + JSON.stringify(res.data));
    commit("updateReductionInfo", res.data);
  },
  // 本体設定取得
  getSettings: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getSettings apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.GETSETTINGS.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getSettings api response = " + JSON.stringify(res.data));
    commit("updateSettings", res.data);
  },
  // 運転モード取得
  getOperationSettings: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getOperationSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getOperationSettings apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.GETSETTINGS_OP.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getOperationSettings api response = " + JSON.stringify(res.data));
    commit("updateOperationSettings", res.data);
  },
  // 冷蔵庫機能一覧
  getFunctionList: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getFunctionList start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getFunctionList apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.FUNCTIONLIST.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getFunctionList api response = " + JSON.stringify(res.data));
    commit("updateFunctionList", res.data);
  },
  // 本体設定の一時記憶
  updateSettingsBuffer: ({ commit}, setData: FridgeDetailsSetSettingsList | null) => {
    NativeClient.sendDebugLog("actions.ts updateSettingsBuffer start");
    commit("updateSettingsBuffer", setData);
  },
  // 本体設定
  registSettings: async ({ commit }, setData: FridgeDetailsSetSettingsList) => {
    NativeClient.sendDebugLog("actions.ts registSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts registSettings apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.SETSETTINGS.replace("$applianceId", targetApplianceId);
    NativeClient.sendDebugLog("actions.ts registSettings apiPath = " + apiPath);
    NativeClient.sendDebugLog("actions.ts registSettings param = " + JSON.stringify(setData));
    const res = await apiFridgeClient.put(apiPath, setData);
    NativeClient.sendDebugLog("actions.ts registSettings api response = " + JSON.stringify(res.data));
    commit("updateResultSettings", res.data);
  },
  // PUSH通知設定の一時記憶
  updatePushSettingsBuffer: ({ commit }, setData: FridgeDetailsPushSettings | null) => {
    NativeClient.sendDebugLog("actions.ts updatePushSettingsBuffer start");
    commit("updatePushSettingsBuffer", setData);
  },
  // クーリングアシストのトップ画面の洗濯中のタブ
  updateCoolingAssistTopTab: ({ commit }, index: number | null) => {
    commit("updateCoolingAssistTopTab", index);
  },
  // クーリングアシスト用の設定データ取得
  getCoolingAssistSettings: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getCoolingAssistSettings start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getCoolingAssistSettings apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.GETCOOLINGASSISTSETTINGS.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getCoolingAssistSettings api response = " + JSON.stringify(res.data));
    commit("updateCoolingAssistSettings", res.data);
  },
  // クーリングアシスト設定
  setCoolingAssist: async ({ commit }, param: FridgeCoolingAssistSettingItem) => {
    NativeClient.sendDebugLog("actions.ts setCoolingAssist start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts setCoolingAssist apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.SETSETTINGS.replace("$applianceId", targetApplianceId);
    NativeClient.sendDebugLog("actions.ts setCoolingAssist apipath = " + apiPath);
    NativeClient.sendDebugLog("actions.ts setCoolingAssist api param = " + JSON.stringify(param));
    const res = await apiFridgeClient.put(apiPath, param);
    NativeClient.sendDebugLog("actions.ts setCoolingAssist api response = " + JSON.stringify(res.data));
  },
  // クーリングアシストのマイリスト（マイリスト）取得
  getMyAssist: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getMyAssist start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts getMyAssist apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.MYLIST.replace("$applianceId", targetApplianceId);
    const res = await apiFridgeClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getMyAssist api response = " + JSON.stringify(res.data));
    commit("updateMyAssist", res.data);
  },
  // クーリングアシストのマイリスト（マイリスト）への登録
  registMyAssist: async ({ commit }, setData: FridgeDetailsMyAssistSettingItem) => {
    NativeClient.sendDebugLog("actions.ts registMyAssist start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts registMyAssist apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.MYLIST.replace("$applianceId", targetApplianceId);
    const param: { [name: string]: number | string } = {};
    param["nickname"] = setData.nickname;
    param["cooloven_mode"] = setData.cooloven_mode;
    param["cooloven_time"] = setData.cooloven_time;
    if (setData.valid_second) {
      param["cooloven_second"] = setData.cooloven_second;
    }
    NativeClient.sendDebugLog("actions.ts registMyAssist api param = " + JSON.stringify(param));
    const res = await apiFridgeClient.post(apiPath, param);
  },
  // クーリングアシストのマイリスト（マイリスト）の更新
  updateMyAssist: async ({ commit }, setData: FridgeDetailsMyAssistSettingItem) => {
    NativeClient.sendDebugLog("actions.ts updateMyAssist start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts updateMyAssist apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.MYLIST.replace("$applianceId", targetApplianceId);
    const param: { [name: string]: number | string } = {};
    param["mylist_id"] = setData.mylist_id;
    param["nickname"] = setData.nickname;
    param["cooloven_mode"] = setData.cooloven_mode;
    param["cooloven_time"] = setData.cooloven_time;
    if (setData.valid_second) {
      param["cooloven_second"] = setData.cooloven_second;
    }
    NativeClient.sendDebugLog("actions.ts updateMyAssist api param = " + JSON.stringify(param));
    const res = await apiFridgeClient.put(apiPath, param);
  },
  // クーリングアシストのマイリスト（マイリスト）の削除
  deleteMyAssist: async ({ commit }, deleteId: number) => {
    NativeClient.sendDebugLog("actions.ts deleteMyAssist start");
    const apiParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("actions.ts deleteMyAssist apiParams = " + JSON.stringify(apiParams));
    const targetApplianceId = translateFridgeParameter(apiParams.applianceId);
    const apiPath = API_URL_FRIDGE.MYLISTDELETE.replace("$applianceId", targetApplianceId).replace("$mylistId", `${deleteId}`);
    NativeClient.sendDebugLog("actions.ts deleteMyAssist api path = " + apiPath);
    const res = await apiFridgeClient.delete(apiPath);
  },
  updateDoorMonitorTabIndex: ({ commit }, index: number) => {
    NativeClient.sendDebugLog("actions.ts updateDoorMonitorTabIndex start");
    commit("updateDoorMonitorTabIndex", index);
  },
  updateDoorMonitorDailyTabIndex: ({ commit }, index: number) => {
    NativeClient.sendDebugLog("actions.ts updateDoorMonitorDailyTabIndex start");
    commit("updateDoorMonitorDailyTabIndex", index);
  },
  updateCoolingAssistEditMode: ({ commit }, isEdit: boolean) => {
    NativeClient.sendDebugLog("actions.ts updateCoolingAssistEditMode start");
    commit("updateCoolingAssistEditMode", isEdit);
  },
  getDisplayDescriptionList: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getDisplayDescriptionList start");
    const apiPath = FILE_URL_FRIDGE.REDUCTION_DESCRIPTION;
    NativeClient.sendDebugLog("actions.ts getDisplayDescriptionList file path = " + apiPath);
    const res = await fridgeFileDownloadClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getDisplayDescriptionList response = " + JSON.stringify(res.data));
    commit("updateDisplayDescriptionList", res.data);;
  },
  getSettingsInitialValue: async ({ commit }) => {
    NativeClient.sendDebugLog("actions.ts getSettingsInitialValue start");
    const apiPath = FILE_URL_FRIDGE.INITIAL_SETTINGS;
    NativeClient.sendDebugLog("actions.ts getSettingsInitialValue file path = " + apiPath);
    const res = await fridgeFileDownloadClient.get(apiPath);
    NativeClient.sendDebugLog("actions.ts getSettingsInitialValue response = " + JSON.stringify(res.data));
    commit("updateSettingsInitialValue", res.data);;
  }
};

export default actions;
